<template>
    <confirmation-page-layout :company="company" :loaded="loaded" :tourlead="tourlead">
        <template v-slot:breadcrumbs>
            <extra-service-breadcrumbs :search-request="searchRequest" :product="product" />
        </template>
        <template v-slot:sidebar>
            <extra-service-search-summary search-disabled :search-request="searchRequest" />
            <extra-service-order-summary
                :product="product"
                :offer="offer"
                :info="basketItem.info"
                :extra-services="extraServices"
                :additional-options="bookingAdditionalOptions"
                :prepare-book-response="prepareBookResponse"
                :search-request="searchRequest"
            />
        </template>
    </confirmation-page-layout>
</template>

<script lang="ts">
    import {mixins, Component} from 'vue-facing-decorator'
    import ConfirmationStatus from '~src/components/booking/confirmationStatus.src'
    import ExtraServiceSearchSummary from '~src/components/extraServices/search/ExtraServiceSearchSummary.vue'
    import ExtraServiceOrderSummary from '~src/components/extraServices/booking/ExtraServiceOrderSummary.vue'
    import {ExtraServiceStoreMixin} from '@/mixins/ExtraServiceStoreMixin.vue'
    import {ConfirmationPageMixin} from '@/mixins/ConfirmationPageMixin.vue'
    import {ExtraServicePageMixin} from '~src/components/extraServices/mixins/ExtraServicePageMixin.vue'
    import ConfirmationPageLayout from '~src/components/parts/ConfirmationPageLayout.vue'
    import ExtraServiceBreadcrumbs from '~src/components/extraServices/ExtraServiceBreadcrumbs.vue'

    @Component({
        components: {
            ExtraServiceBreadcrumbs,
            ConfirmationPageLayout,
            ConfirmationStatus,
            ExtraServiceSearchSummary,
            ExtraServiceOrderSummary,
        },
        async setup() {
            return await useConfirmationPage()
        },
    })
    export class ExtraServiceConfirmationPage extends mixins(
        ExtraServicePageMixin,
        ExtraServiceStoreMixin,
        ConfirmationPageMixin
    ) {
        get basketItem() {
            return this.productStore.basketItem(this.productStore.prepareBookRequest.offerKey)
        }

        get searchRequest() {
            return this.basketItem.searchRequest
        }

        get product() {
            return this.basketItem.product
        }

        get offer() {
            return this.product.offers.find(offer => offer.offerKey === this.basketItem.offerKey)
        }
    }

    export default ExtraServiceConfirmationPage
</script>
